// extracted by mini-css-extract-plugin
module.exports =  {"root":"TanStackTable-module__root--DJNkj"};